<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    怡景站<br>
站点介绍<br>
怡景站位于怡景路与黄贝路交汇处，车站周围有罗湖图书馆、深圳动漫城、荷花市场，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:16	23:05	5号线	3分钟	5分25秒<br>
黄贝岭	06:12	00:16	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	23:05	5号线	4分钟	6分钟<br>
黄贝岭	06:24	00:16	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	00:05	5号线	4分钟	6分钟<br>
黄贝岭	06:24	01:16	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
黄贝路、荷花市场<br><br>
B出入口:<br>
怡景路南侧(西)、怡景社区党群服务中心、景贝小学、东部景区假日专线、峰景台大厦、景贝南住宅区<br><br>
C出入口:<br>
怡景路南侧（东）、罗湖区中医院康复分院、碧波小学、翠园中学初中部<br><br>
D出入口:<br>
怡景路北侧（西）、深圳国家动漫画产业基地、深圳交响乐团音乐厅、湖滨新村、罗湖港人子弟学校<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 荷花市场<br>
218、229、M373、13、17、57、104、214、B909、M555（原65）<br><br>
B出入口:<br>
公交站名： 怡景地铁站①<br>
52、103、113、202、308、M437、E11区间线、M526、M348、大鹏假日专线8、高峰专线5、高快巴士12（原E12）、大梅沙假日专线2<br><br>
C出入口:<br>
公交站名： 怡景地铁站①<br>
52、103、113、202、308、高快巴士12（原E12）、E11区间线、M526、大鹏假日专线8、高峰专线5<br><br>
D出入口:<br>
公交站名： 怡景花园<br>
17、52、103、113、202、23、M348、M437<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


